import React from "react";
import { connect } from "react-redux";
import { hasRoutePermission } from "shared/utils";
import { Field, } from "formik";

const PermissionInputField = ({ route, role, permission, ...props }) => {
  const { dispatch, ...rest } = props;
  let allow = role["id"];
  if (allow !== 1) {
    allow = hasRoutePermission(route, role, permission);
  }

  return allow ? (
    <div>
      <Field
        {...rest}
      >
        {rest.children}
      </Field>
    </div>
  ) : null;
};

const mapStateToProps = ({ role }) => ({
  role,
});

export default connect(mapStateToProps)(PermissionInputField);
